import { render, staticRenderFns } from "./Kontrole.vue?vue&type=template&id=af7ed92a&"
import script from "./Kontrole.vue?vue&type=script&lang=js&"
export * from "./Kontrole.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports